module.exports = __webpack_public_path__ + "img/bookmark-x.96dd164d.svg";